import { Injectable } from '@angular/core';
import { TokenService } from '../auth/token.service';

const STORAGE_KEY_SERVER = 'devServerOverride';

@Injectable({
  providedIn: 'root',
})
export class EndpointsService {
  constructor(private token: TokenService) {}

  get kontorUrl(): string {
    const override = localStorage.getItem(STORAGE_KEY_SERVER);
    return override ?? this.token.serverUrls.kontorserver;
  }
  kontorLogin = 'api/users/login';
  kontorRefreshToken = 'api/users/refresh-token';
  kontorUsers = 'api/users';
  kontorProducts = 'api/products';
  kontorProductChanges = 'api/product-changes';
  kontorProductLogs = 'api/product-logs';
  kontorContacts = 'api/contacts';
  kontorOrders = 'api/orders';
  kontorOrdersUpsert = 'api/orders-upsert';

  // Flow Endpoints
  flowUrl = this.token.serverUrls.flowUrl;
  resetContacts = 'webhook/kontor/resetGoogleContacts'
  proxyLexware = 'webhook/kontor/proxyLexware'

  // PDF Endpoints
  generateConfirm = 'webhook/kontor/generateConfirm';
  generateWhole = 'webhook/kontor/generatewhole';
  generateExternal = 'webhook/kontor/generateExternal';

  // Bypass Endpoints
  lexwarestatus = 'webhook/kontor/lexwarestatus';
  lexGetContacts = 'webhook/kontor/lexcontacts';
  lexCreateContact = 'webhook/kontor/lexcreatecontact';
  lexCreateDeliveryNote = 'webhook/kontor/lexcreatedeliverynote';
  lexCreateInvoice = 'webhook/kontor/lexcreateinvoice';

  // Lexware Endpoints
  lewwareContacts = 'v1/contacts';
  lexwareDeliveryNote = 'v1/delivery-notes';
  lexwareInvoices = 'v1/invoices';

  // Payload CMS Endpoints
  kontorDefaults = 'api/defaults';
  kontorLogInvoice = 'api/log-invoice';
  kontorInvoices = 'api/invoices';

  // Deliveries
  kontorCreateDelivery = 'api/create-delivery';
  kontorRemainingQuantities = 'api/remaining-quantities';
  kontorLogDeliveryInvoice = 'api/log-delivery-invoice';
  kontorDeliveries = 'api/deliveries';

  // Versions (using built-in Payload endpoint)
  kontorOrderVersions = 'api/orders/versions';

  // Comments
  kontorAddOrderComment = 'api/order-comment-add';

  // Lexware Runner
  kontorLexwareStatus = 'api/orders-lexware-status';
  kontorLexwareQueue = 'api/lexware-queue-runner';
  kontorLexwareTransferTrigger = 'api/lexware-transfer-trigger';
  kontorLexwareQueuePendingCount = 'api/lexware-queue-pending-count';
  kontorLexwareQueueConfirm = 'api/lexware-queue-confirm';
  kontorOrdersCloseInvoicing = 'api/orders-close-invoicing';
  kontorOrdersChangeOwner = 'api/orders-change-owner';
  kontorLexwareSettings = 'api/globals/lexware-settings';

  // Karma B2B
  kontorCreateKarmaCart = 'api/create-karma-cart';
  kontorFetchAndImportKarma = 'api/fetch-and-import-karma';
  kontorImportStatus = 'api/globals/import-status';
  kontorKarmaUnavailableProducts = 'api/karma-unavailable-products';
  kontorKarmaCartLog = 'api/karma-cart-log';

  // Feedback
  kontorFeedback = 'api/feedback';

  // Image Proxy
  kontorProxyImage = 'api/proxy-image';
  get kontorProxyImageBase() { return `${this.kontorUrl}/${this.kontorProxyImage}`; }
}
